import { jsx as h, jsxs as a } from "react/jsx-runtime";
function v(e) {
  return /* @__PURE__ */ h("svg", { height: "1em", viewBox: "0 0 24 24", width: "1em", ...e, children: /* @__PURE__ */ a("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ h("path", { d: "M4 4h16v16H4z" }),
    /* @__PURE__ */ h(
      "path",
      {
        d: "M12.5 4C15.532 4 18 6.467 18 9.5a5.5 5.5 0 01-2.615 4.68.501.501 0 01.115.32v2a.5.5 0 01-.5.5h-1v2.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V17h-1a.5.5 0 01-.5-.5v-2c0-.121.043-.233.115-.32A5.5 5.5 0 017 9.5C7 6.467 9.467 4 12.5 4zm.5 13h-1v2h1v-2zm1.5-2h-4v1h4v-1zm-2-10C10.019 5 8 7.019 8 9.5s2.019 4.5 4.5 4.5S17 11.981 17 9.5 14.981 5 12.5 5zm-2.48 3a.5.5 0 010 1c-.276 0-.505-.224-.505-.5s.219-.5.495-.5h.01zm1.5-.5a.5.5 0 010 1c-.276 0-.505-.224-.505-.5s.219-.5.495-.5h.01zm-1-1a.5.5 0 010 1c-.276 0-.505-.224-.505-.5s.219-.5.495-.5h.01zm1.5-.5a.5.5 0 010 1c-.276 0-.505-.224-.505-.5s.219-.5.495-.5h.01z",
        fill: "currentColor"
      }
    )
  ] }) });
}
export {
  v as default
};
